<template>
  <Card class="contactSalesBanner">
    <div class="section leftSide">
      <HeadingLarge>Not sure what you need?</HeadingLarge>
      <ButtonSecondary
        class="ctaButton"
        :data-test-id="$testId('ctaButton')"
        text="Contact Sales"
        @click="handleCtaClick"
      />
    </div>
    <div class="section rightSide">
      <ParagraphBody class="limitWidth">
        Talk to an expert to determine the best options for your organization.
      </ParagraphBody>
      <ParagraphBody class="limitWidth">
        Learn about special pricing options for education and non-profit sectors.
      </ParagraphBody>
    </div>
  </Card>
</template>

<script>
import {
  ButtonSecondary,
  Card,
  HeadingLarge,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { UiEvents } from '@jumpcloud/ui-events-vue';

export default {
  name: 'ContactSalesBanner',

  components: {
    ButtonSecondary,
    Card,
    HeadingLarge,
    ParagraphBody,
  },

  methods: {
    handleCtaClick() {
      UiEvents.triggerButtonClicked({
        description: 'contact sales button clicked in contact sales banner',
        page: this.$page,
        section: 'contact sales banner',
        text: 'Contact Sales',
      });

      this.$emit('contactSales');
    },
  },
};
</script>

<style scoped>
.contactSalesBanner {
  --card-background: var(--jcTertiary50);

  display: flex;
  gap: var(--jc-spacer-large);
}

.ctaButton {
  width: fit-content;
}

.section {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.leftSide {
  align-items: flex-end;
}

.rightSide {
  align-items: flex-start;
  text-align: left;
}

.limitWidth {
  max-width: 25rem;
}
</style>
